export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20overhead%20view%20of%20diverse%20fashion%20and%20lifestyle%20products%20on%20a%20dark%20charcoal%20slate%20surface%2C%20shoes%2C%20bags%2C%20watches%2C%20sunglasses%2C%20and%20accessories%20scattered%20organically%2C%20dramatic%20top-down%20lighting%2C%20luxury%20editorial%20photography%2C%20deep%20charcoal%20and%20metallic%20accents%2C%20high-end%20composition&width=1800&height=700&seq=cta-bg-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet premium shopping collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-none">
              your curated<br />list starts here
            </h2>
            <div className="mt-10">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 whitespace-nowrap px-6 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer group"
              >
                <span>Visit Main Site</span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 group-hover:bg-primary-500 transition-colors">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="lg:text-right">
            <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-md lg:ml-auto">
              Built for shoppers in the US and Europe who want a faster, smarter way to discover top Sugargoo finds. No more endless scrolling — just organized, verified product links ready to explore.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}